/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { AddIcon } from "@dotnet/telematics-design-system";

import { COMPANY_CARDS_LIMITS } from "../../../../../../../../Pages/Companies/types";
import {
  COMPANIES_ACTIONS,
  ICON_DEFAULT_STYLE
} from "../../../../../../../../shared";
import Button from "../../../../../../../Button/Button";
import { useDialog } from "../../../../../../../PageHeader/actions/hooks/useDialog";
import Tooltip from "../../../../../../../Tooltip/Tooltip";
import AddNewEmailRecipientDialog from "./AddNewEmailRecipientDialog";

interface AddNewEmailRecipientProps {
  companyId: string;
  emailCount: number;
}

const AddNewEmailRecipient = ({
  companyId,
  emailCount
}: AddNewEmailRecipientProps) => {
  const { t } = useTranslation();

  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  const isDisabled = emailCount >= COMPANY_CARDS_LIMITS.MaxResourceCount;

  const handleAddEmailClick = () => {
    openDialog(COMPANIES_ACTIONS.AddNewEmailRecipient);
  };

  const handleCloseDialog = () => {
    closeDialog(COMPANIES_ACTIONS.AddNewEmailRecipient);
  };

  return (
    <>
      <Tooltip
        title={t(`Details##email limit reached`, {
          currCount: emailCount,
          maxCount: COMPANY_CARDS_LIMITS.MaxResourceCount
        })}
        placement="top-end"
        hasArrow
        size="medium"
        disableHoverListener={!isDisabled}
      >
        <span>
          <Button
            data-testid="add-new-email-button"
            color="secondary"
            onClick={handleAddEmailClick}
            size="tiny"
            variant="iconLeft"
            disabled={isDisabled}
            icon={
              <AddIcon
                css={css({ ...ICON_DEFAULT_STYLE, marginRight: "-2px" })}
              />
            }
          >
            {t("Company cards##add new")}
          </Button>
        </span>
      </Tooltip>

      <AddNewEmailRecipientDialog
        companyId={companyId}
        isOpen={isDialogOpen[COMPANIES_ACTIONS.AddNewEmailRecipient]}
        handleClose={handleCloseDialog}
      />
    </>
  );
};

export default AddNewEmailRecipient;
